import { useState } from 'react';
import { Button, Text, UploadFileDialog } from 'shell/components';

const ALLOWED_FILE_TYPES = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'text/csv',
];

const UploadFileDialogDemo = () => {
    const [dialog1, setDialog1] = useState({ open: false });
    const [dialog2, setDialog2] = useState({ open: false });
    const [dialog3, setDialog3] = useState({ open: false });

    return (
        <>
            <Text variant={'sh1'}>UploadFileDialog</Text>

            <Button onClick={() => setDialog1((current) => ({ ...current, open: true }))}>Upload Submissions</Button>
            <UploadFileDialog
                allowedFileTypes={ALLOWED_FILE_TYPES}
                description={'You can upload up to 600 files at a time.'}
                max={600}
                title={'Upload Submissions'}
                open={dialog1.open}
                onClickUpload={() => {}}
                onClose={() => setDialog1((current) => ({ ...current, open: false }))}
            />

            <Button onClick={() => setDialog2((current) => ({ ...current, open: true }))}>
                Upload Content Bank Resources
            </Button>
            <UploadFileDialog
                allowedFileTypes={ALLOWED_FILE_TYPES}
                description={'Please upload only essential materials for this assignment (max 200MB) to avoid errors.'}
                max={0}
                title={'Upload Files'}
                open={dialog2.open}
                onClickUpload={() => {}}
                onClose={() => setDialog2((current) => ({ ...current, open: false }))}
            />

            <Button onClick={() => setDialog3((current) => ({ ...current, open: true }))}>
                Upload Student Submission
            </Button>
            <UploadFileDialog
                allowedFileTypes={ALLOWED_FILE_TYPES}
                description={''}
                max={1}
                title={'Upload Submission'}
                open={dialog3.open}
                onClickUpload={() => {}}
                onClose={() => setDialog3((current) => ({ ...current, open: false }))}
            />
        </>
    );
};

export default UploadFileDialogDemo;
